<div class class="baukosten-container-outer-div" id='baukostenContainer' style="overflow-x: auto;white-space: nowrap;">

    <dx-data-grid #selectedTemplateGrid [id]="'selectedTemplateGrid'" [dataSource]="planCosts" keyExpr="costPlanId"
        class="gpd-datagrid" 
        [showBorders]="true"
        (onRowInserted)="onCostRowInserted($event)"
        (onSelectionChanged)="onCostSelectionChanged($event)"
        (onEditorPrepared)="onCostEditorPrepared($event)" (onEditingStart)="onCostEditingStart($event)"
        [repaintChangesOnly]="true" (onCellDblClick)="showCost($event, projectPlanCosts)"
        [editing]="{ mode: 'form', texts: { saveRowChanges: confirmText, cancelRowChanges: cancelText }}"
        showRowLines="true" [repaintChangesOnly]="true" [hoverStateEnabled]="true" [rowAlternationEnabled]="true"
        height="100%" width="100%">
        <dxo-editing [useIcons]="true"></dxo-editing>
        <dxo-selection [mode]="planIsInDraft ? 'multiple' : 'none'" showCheckBoxesMode="always"
            selectAllMode="allPages"></dxo-selection>

        <dxo-toolbar>
            <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
            <dxi-item width="50%">
                <div class="gt-flex-dir-row" style="gap:8px">
                    @if (planIsInDraft && selectedCostPlanIds.length > 0) {
                        <app-gpd-button type="danger" icon="delete" i18n-text="@@Delete" text="Delete"
                            (onClick)="initDeleteSelectedCosts()">
                        </app-gpd-button>
                    }
                    <app-gpd-button i18n-text="@@importATemplate" text="IMPORT A TEMPLATE" icon="import"
                        (onClick)="importTemplate($event)"
                        [disabled]="!planIsInDraft">
                    </app-gpd-button>
                    <app-gpd-button i18n-text="@@addCosts" text="ADD NEW COST" icon="add"
                        [disabled]="!planIsInDraft" (onClick)="addCostRow($event)"
            >
                    </app-gpd-button>
                    <app-gpd-button *ngIf="planIsInDraft" [text]="freezeBudgetText"
                        icon="archive" (onClick)="initFreezeBudget()">
                    </app-gpd-button>
                    <app-gpd-button *ngIf="!planIsInDraft && userPermissions.isAdministrator == true"
                        [text]="unfreezeBudgetText" icon="reactivate"
                        (onClick)="initUnfreezeBudget()">
                    </app-gpd-button>
                </div>
            </dxi-item>
        </dxo-toolbar>

        <dxo-editing mode="form" [confirmDelete]="false" width="100%">
            <dxo-form colCount="1">
                <dxi-item template="templateCostConfigForm" colSpan="2">
                    <div *dxTemplate="let item of 'templateCostConfigForm'">
                        <form (submit)="$event.preventDefault(); onCostRowUpdated($event, projectPlanCosts)">
                            <dx-validation-group>
                                <dx-form [formData]="selectedTemplateCost" [colCount]="1" width="100%"
                                    validationGroup="templateCostConfigForm">
                                    <dxi-item itemType="group" [colCount]="1" [colSpan]="1">

                                        <dxi-item dataField="costCategoryId" template="editCategoryTemplate"
                                            [colSpan]="1">
                                            <dxo-label i18n-text="@@Category" text="Category" />
                                            <div *dxTemplate="let item of 'editCategoryTemplate'">
                                                <dx-drop-down-box [(value)]="selectedTemplateCost.costCategoryId"
                                                    valueExpr="id" displayExpr="categoryName" i18n-placeholder
                                                    placeholder="Select a category..." [showClearButton]="true"
                                                    [(opened)]="isTreeBoxOpened" [dataSource]="treeDataSourceSorted"
                                                    [showDropDownButton]="true">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"
                                                            i18n-message="@@categoryIsRequired"
                                                            message="Category is required">
                                                        </dxi-validation-rule>
                                                    </dx-validator>

                                                    <div *dxTemplate="let data of 'content'">
                                                        <dx-tree-view [dataSource]="treeDataSourceSorted"
                                                            dataStructure="plain" keyExpr="treeId"
                                                            parentIdExpr="treeCategoryId" selectionMode="single"
                                                            displayExpr="categoryName" [selectByClick]="true"
                                                            [searchEnabled]="true"
                                                            (onItemSelectionChanged)="treeView_itemSelectionChanged($event, selectedTemplateCost)"
                                                            (onInitialized)="treeView_itemSelectionChanged($event, selectedTemplateCost)">
                                                        </dx-tree-view>
                                                    </div>
                                                </dx-drop-down-box>
                                            </div>
                                        </dxi-item>

                                        <dxi-item itemType="group" [colSpan]="1" [colCount]="3">
                                            <dxi-item dataField="isKwpCost" editorType="dxCheckBox" [colSpan]="1"
                                                [editorOptions]="{editorType: 'dxCheckBox',value:selectedTemplateCost.isKwpCost,
                                             onValueChanged:isKwpCostChanged, onInitialized:iskwpInitialized(selectedTemplateCost)}">
                                                <dxo-label i18n-text="@@isKwpCost" text="Cost per size unit" />
                                            </dxi-item>

                                            <dxi-item i18n="@@attractsUst" dataField="attractsUst"
                                                editorType="dxCheckBox" [colSpan]="1"
                                                [editorOptions]="{editorType: 'dxCheckBox',value:selectedTemplateCost.attractsUst}">
                                                <dxo-label i18n-text text="Attracts Ust" />
                                            </dxi-item>

                                            <!-- <dxi-item dataField="isSiteCost" editorType="dxCheckBox" [colSpan]="1"
                                                [editorOptions]="{editorType: 'dxCheckBox',value:selectedTemplateCost.isSiteCost}">
                                                <dxo-label i18n-text="@@isSiteCost" text="Site Cost" />
                                            </dxi-item> -->
                                        </dxi-item>

                                        <!--               <dxi-item dataField="ust" editorType="dxNumberBox" [colSpan]="1"
                                            [editorOptions]="{maxLength: 50, format: '#,##0.# %'}">
                                            <dxo-label i18n-text text="Ust" />
                                        </dxi-item> -->

                                        <dxi-item dataField="costNett" editorType="dxNumberBox" *ngIf="EPKWFormatting"
                                            [colSpan]="1" [editorOptions]="{ maxLength: 50, format: '#,##0.00 ' + perUnitLabel(sizeUnit) }"
                                            [validationRules]="[ { type: 'required', message: costNettRequired } ]">
                                            <dxo-label i18n-text text="Cost Nett" />
                                        </dxi-item>

                                        <dxi-item dataField="costNett" editorType="dxNumberBox" *ngIf="!EPKWFormatting"
                                            [colSpan]="1" [editorOptions]="{ maxLength: 50,  format: '#,##0.00 €' }"
                                            [validationRules]="[ { type: 'required', message: costNettRequired } ]">
                                            <dxo-label i18n-text text="Cost Nett" />
                                        </dxi-item>

                                        <dxi-item dataField="" template="timingTemplate" [colSpan]="1"
                                            [validationRules]="[ { type: 'required', message: milestoneRequired } ]">
                                            <dxo-label i18n-text text="Milestone Offset" />
                                            <div *dxTemplate="let item of 'timingTemplate'" class="gt-flex-dir-row">
                                                <dx-number-box width="100px"
                                                    [(value)]="selectedTemplateCost.milestoneOffsetValue">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"
                                                            i18n-message="@@milestoneIsRequired"
                                                            message="Milestone information is required">
                                                        </dxi-validation-rule>
                                                    </dx-validator>
                                                </dx-number-box>
                                                <span i18n class="form-inline-span-text">weeks</span>
                                                <dx-select-box width="auto" i18n-placeholder placeholder="Before/After"
                                                    [dataSource]="milestoneOffsetDirections" displayExpr="text"
                                                    valueExpr="text"
                                                    [(value)]="selectedTemplateCost.milestoneOffsetDirection"
                                                    [showClearButton]="true">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"
                                                            i18n-message="@@milestoneIsRequired"
                                                            message="Milestone information is required">
                                                        </dxi-validation-rule>
                                                    </dx-validator>
                                                </dx-select-box>

                                                <dx-select-box width="auto" i18n-placeholder
                                                    placeholder="Select Milestone" [dataSource]="milestones"
                                                    (onSelectionChanged)="changeMilestone($event)"
                                                    [dropDownOptions]="{ width: 300 }"
                                                    [(value)]="selectedTemplateCost.costMilestoneId" valueExpr="itemId"
                                                    displayExpr="itemName" [showClearButton]="true">
                                                    <dx-validator>
                                                        <dxi-validation-rule type="required"
                                                            i18n-message="@@milestoneIsRequired"
                                                            message="Milestone information is required">
                                                        </dxi-validation-rule>
                                                    </dx-validator>
                                                </dx-select-box>

                                                <span i18n class="form-inline-span-text">milestone.</span>
                                            </div>
                                        </dxi-item>

                                        <dxi-item dataField="notes" editorType="dxTextArea" [colSpan]="1"
                                            [editorOptions]="{maxLength: 255, value:selectedTemplateCost.notes}">
                                            <dxo-label i18n-text text="Notes" />
                                        </dxi-item>

                                    </dxi-item>

                                    <dxi-item itemType="group" [colCountByScreen]="{ sm: 1, md: 1 }" [colSpan]="1"
                                        cssClass="buttons-group" [verticalAlignment]="true">
                                        <dx-button i18n-text="@@cancel" text="Cancel" stylingMode="contained"
                                            class="gt-button gt-btn-left gt-blk-txt add-site-icon"
                                            [useSubmitBehavior]="false"
                                            (onClick)="onCostEditCanceling($event)"></dx-button>

                                        <dx-button i18n-text="@@confirmCaps" text="CONFIRM" stylingMode="contained"
                                            validationGroup="templateCostConfigForm" [useSubmitBehavior]="true"
                                            class="gt-button gt-btn-right gt-blk-txt add-site-icon"></dx-button>
                                    </dxi-item>

                                </dx-form>
                            </dx-validation-group>
                        </form>
                    </div>
                </dxi-item>
            </dxo-form>
        </dxo-editing>

        <dxi-column dataField="primaryCostCategoryName" [groupIndex]="0" groupCellTemplate="groupCellTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'groupCellTemplate'">
            {{data.key}}
        </div>

        <dxi-column dataField="costCategoryId" i18n-caption="@@Category" caption="Category"
            [editorOptions]="{maxLength: 50}">
            <dxo-lookup [dataSource]="treeDataSourceSorted" valueExpr="id" displayExpr="categoryName"></dxo-lookup>
        </dxi-column>

        <dxi-column dataField="isKwpCost" i18n-caption="@@isKwpCost" caption="Cost per size unit">
        </dxi-column>

        <dxi-column dataField="attractsUst" i18n-caption="@@attracstUst" caption="Attracts Ust">
        </dxi-column>

        <!--       <dxi-column dataField="ust" i18n-caption="@@ust" caption="Ust" format="#,##0.# %">
        </dxi-column> -->

        <!-- <dxi-column dataField="isSiteCost" i18n-caption="@@isSiteCost" caption="Site Cost">
        </dxi-column> -->

        <dxi-column dataField="costNett" i18n-caption="@@nettAmount" caption="Nett Amount"
            [editorOptions]="{maxLength: 50, format: nettFormat}" [cellTemplate]="cellTemplate" [format]="nettFormat">
        </dxi-column>

        <dxi-column dataField="notes" i18n-caption="@@notes" caption="Notes">
        </dxi-column>

        <dxi-column dataField [visible]="planIsInDraft" allowEditing=" false" cellTemplate="buttonCellTemplate"
            [formItem]="{ visible: false }" [width]="70">
            <div *dxTemplate="let item of 'buttonCellTemplate'">
                <app-gpd-button icon="edit" type="text" (onClick)="initEditCost($event, item)"
                    [disabled]="!planIsInDraft"></app-gpd-button>
            </div>
        </dxi-column>

    </dx-data-grid>

</div>

<dx-toast [(visible)]="toastVisible" [message]="message" [type]="type"></dx-toast>

<dx-popup [visible]="importTemplateVisible" (onHiding)="importTemplateVisible = false" [width]="'auto'"
    [maxWidth]="'70%'" [height]="'auto'" [maxHeight]="'70%'">
    <dx-data-grid #masterGrid id="masterGrid" [dataSource]="costTemplates" [repaintChangesOnly]="true" [keyExpr]="'id'"
        class="templateCostConfigForm" (onCellClick)="openTemplate($event)" showRowLines="true"
        [hoverStateEnabled]="true" [rowAlternationEnabled]="true">
        <dxo-search-panel i18n-placeholder="@@projectCostsSearch" placeholder="Search project costs..." [visible]="true"></dxo-search-panel>
        <dxo-header-filter visible="true"></dxo-header-filter>
        <dxo-toolbar>
            <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
            <dxi-item width="50%">
                <div class="gt-flex-dir-row">
                    <dx-button i18n-text="@@addCostTemplateCaps" text="ADD COST TEMPLATE"
                        [visible]="userPermissions.isAdministrator == true || userPermissions.canEdit == true"
                        icon="add" (onClick)="addCostTemplate()"
                        class="gt-button gt-btn-right gt-blk-txt add-site-icon">
                    </dx-button>
                </div>
            </dxi-item>
        </dxo-toolbar>

        <dxo-editing mode="form" [confirmDelete]="false">
            <dxo-form colCount="1">
                <dxi-item template="templateConfigForm">
                    <div *dxTemplate="let item of 'templateConfigForm'">
                        <form (submit)="$event.preventDefault(); saveCostTemplate($event)">
                            <dx-form [formData]="selectedTemplate" [colCount]="1" validationGroup="templateConfigForm">
                                <dxi-item itemType="group" [colCount]="1">

                                    <dxi-item i18n="@@templateName" dataField="templateName" editorType="dxTextBox"
                                        i18n-caption caption="Template Name"
                                        [validationRules]="[ { type: 'required', message: titleRequired }]">
                                        <dxo-label i18n-text text="Template Name" />
                                    </dxi-item>

                                    <dxi-item i18n="@@areaType" dataField="areaTypeId" editorType="dxSelectBox"
                                        [editorOptions]="{editorType: 'dxSelectBox',  dataSource: projectAreaTypes,
                                         displayExpr: 'itemName', valueExpr: 'itemId', searchEnabled: false, onValueChanged: setAreaType }">
                                        <dxo-label i18n-text text="Area Type" />
                                    </dxi-item>

                                    <dxi-item i18n="description" dataField="sizeRange" editorType="dxSelectBox"
                                        i18n-caption caption="Description"
                                        [editorOptions]="{editorType: 'dxSelectBox',dataSource: projectSizeRanges,displayExpr: 'itemName',
                                        valueExpr: 'itemName',searchEnabled: true,acceptCustomValue: true,onCustomItemCreating: addCustomSizeRangeValue}">
                                        <dxo-label i18n-text text="Description" />
                                    </dxi-item>
                                </dxi-item>

                                <dxi-item itemType="group" [colCountByScreen]="{ sm: 1, md: 1 }"
                                    cssClass="buttons-group" [verticalAlignment]="true">
                                    <dx-button i18n-text="@@cancel" text="Cancel" stylingMode="contained"
                                        class="gt-button gt-btn-left gt-blk-txt add-site-icon"
                                        [useSubmitBehavior]="false"
                                        (onClick)="onTemplateEditCanceling($event)"></dx-button>

                                    <dx-button i18n-text="@@confirmCaps" text="CONFIRM" stylingMode="contained"
                                        validationGroup="templateConfigForm" [useSubmitBehavior]="true"
                                        class="gt-button gt-btn-right gt-blk-txt add-site-icon"></dx-button>
                                </dxi-item>

                            </dx-form>
                        </form>
                    </div>
                </dxi-item>
            </dxo-form>
        </dxo-editing>

        <dxi-column dataField="templateName" cellTemplate="nameTemplate" i18n-caption caption="Template Name"
            allowFiltering="true">
            <div *dxTemplate="let item of 'nameTemplate'">
                <div class="cell-with-buttons">
                    <span>{{item.data.templateName}}</span>
                </div>
            </div>
        </dxi-column>

        <dxi-column dataField="areaTypeId" i18n-caption caption="Area Type" allowFiltering="true">
            <dxo-lookup [dataSource]="projectAreaTypes" valueExpr="itemId" displayExpr="itemName"></dxo-lookup>
        </dxi-column>

        <dxi-column dataField="sizeRange" cellTemplate="sizeTemplate" editCellTemplate="editSizeTemplate"
            allowFiltering="true" i18n-caption caption="Description">
            <div *dxTemplate="let item of 'sizeTemplate'">
                <span>{{item.data.sizeRange}}</span>
            </div>
        </dxi-column>
    </dx-data-grid>
</dx-popup>

<dx-popup [visible]="addToExsistingCostsPopupVisible" [title]="addToExisitngCostsText" [width]="'auto'"
    [height]="'auto'">
    <span i18n>Would you like to add these Template Costs to the exisiting
        costs?</span>
    <div class="gt-flex-dir-row" style="justify-content: space-between;margin-top:15px;">
        <dx-button i18n-text [text]="'No'" class="gt-button gt-btn-right gt-blk-txt add-site-icon"
            (onClick)="addToExsistingCostsPopupVisible = false"></dx-button>
        <dx-button i18n-text [text]="'Yes'" class="gt-button gt-btn-right gt-blk-txt add-site-icon"
            (onClick)="addTemplateCosts(templateCostsToAdd)"></dx-button>
    </div>
</dx-popup>

<dx-popup [visible]="deleteSelectedCostsPopupVisible" [title]="deletePlanCostTitle" [width]="'auto'" [height]="'auto'">
    <span i18n="@@deleteSelectedCostsConfirm">Are you sure you want to delete the selected entries?</span>
    <div i18n="@@deleteSelectedCostsCount">Selected entries: {{ selectedCostPlanIds.length }}</div>
    <div class="gt-flex-dir-row" style="justify-content: space-between;margin-top:15px;">
        <app-gpd-button i18n-text="@@budgetActionCancel" text="Cancel" (onClick)="deleteSelectedCostsPopupVisible = false"></app-gpd-button>
        <app-gpd-button type="danger" i18n-text="@@Delete" text="Delete" (onClick)="deleteSelectedCosts()"></app-gpd-button>
    </div>
</dx-popup>

<dx-popup [visible]="freezeBudgetPopupVisible" [title]="freezeBudgetTitle" [width]="'auto'" [height]="'auto'">
    <span>{{freezeBudgetMessage}}</span>
    <div class="gt-flex-dir-row" style="justify-content: space-between;margin-top:15px;">
        <app-gpd-button i18n-text="@@budgetActionCancel" text="Cancel" (onClick)="freezeBudgetPopupVisible = false"></app-gpd-button>
        <app-gpd-button i18n-text="@@budgetActionConfirm" text="Confirm" (onClick)="freezeBudget()"></app-gpd-button>
    </div>
</dx-popup>

<dx-popup [visible]="unfreezeBudgetPopupVisible" [title]="unfreezeBudgetTitle" [width]="'auto'" [height]="'auto'">
    <span>{{unfreezeBudgetMessage}}</span>
    <div class="gt-flex-dir-row" style="justify-content: space-between;margin-top:15px;">
        <app-gpd-button i18n-text="@@budgetActionCancel" text="Cancel" (onClick)="unfreezeBudgetPopupVisible = false"></app-gpd-button>
        <app-gpd-button i18n-text="@@budgetActionConfirm" text="Confirm" (onClick)="unfreezeBudget()"></app-gpd-button>
    </div>
</dx-popup>
